import systemKefu from "./system-kefu.vue";

let Plugin = {},
  vueClass = Vue.extend(systemKefu),
  vueInstance;

Plugin.install = function(Vue, opt) {
  opt.root.systemKefu = function() {
    if (!vueInstance) {
        let el = document.createElement("div");
        document.querySelector("body").appendChild(el);

        vueInstance = new vueClass({
        el: el,
        router: opt.router,
        });
    }

    // return vueInstance;
    return vueInstance.show(...arguments);
  };
};

export default Plugin;
